import { PHONE_LENGTH, RUSSIA_PHONE_CODE } from '../constansts/index.js';
import { PHONE_START_REGEXP } from '../constansts/regExp.js';

const normalizePhone = (dirtyPhone) => dirtyPhone.replace(/[-_()\s]/g, '');
const getOnlyDigets = (string) => string.match(/\d/g)?.join('');
const normalizeRussianCountryCode = (phone) => {
    const reg = new RegExp(PHONE_START_REGEXP);
    if (!reg.test(phone))
        return phone;
    return phone.replace(PHONE_START_REGEXP, RUSSIA_PHONE_CODE);
};
// export const isPhoneLengthValid = (length: number) => length >= 10 && length <= 12;
const isPhoneLengthValid = (phone) => {
    const phoneClear = normalizePhone(phone);
    const numbers = getOnlyDigets(phoneClear);
    if (!numbers)
        return false;
    return numbers.length === PHONE_LENGTH;
};
const isPhoneCodeAllowed = (phone) => {
    const phoneClear = normalizePhone(phone);
    const defCodes = [
        495, 499, 900, 901, 902, 903, 904, 905, 906, 908, 909, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921,
        922, 923, 924, 925, 926, 927, 928, 929, 930, 931, 932, 933, 934, 935, 936, 937, 938, 939, 949, 950, 951, 952, 953, 958,
        959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 977, 978, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990,
        991, 992, 993, 994, 995, 996, 997, 999,
    ];
    const regExp = /^[\+7|7|8]{1,2}\s?\(?(\d{3})\)?\s?\d+$/g;
    const defCode = regExp.exec(phoneClear);
    return defCode !== null && defCodes.indexOf(parseInt(defCode[1], 10)) !== -1;
};
const formatPhoneToDisplayView = (dirtyPhone) => {
    const phone = normalizePhone(dirtyPhone);
    const { length } = phone;
    const formatedPhone = `${phone.slice(0, length - 10)} ${phone.slice(length - 10, length - 7)} ${phone.slice(length - 7, length - 4)} ${phone.slice(length - 4, length - 2)} ${phone.slice(length - 2, length)}`;
    return formatedPhone.startsWith('7') ? `+${formatedPhone}` : formatedPhone;
};
const handlePhoneBeforeMaskedStateChange = (states) => {
    const { nextState,
    // previousState
     } = states;
    const { enteredString } = nextState; // Почему то не указано в типизации
    const reg = new RegExp(PHONE_START_REGEXP);
    const clearedEnteredString = enteredString?.trim();
    // ввести за раз больше 1 символа можно только с помощью paste
    if (clearedEnteredString && clearedEnteredString.length > 1) {
        if (reg.test(clearedEnteredString))
            return {
                ...nextState,
                value: clearedEnteredString.replace(PHONE_START_REGEXP, RUSSIA_PHONE_CODE),
            };
        // const isEmptyPreviousValue = normalizePhone(previousState.value) === RUSSIA_PHONE_CODE;
        // if (isEmptyPreviousValue && isPhoneLengthValid(`${RUSSIA_PHONE_CODE}${enteredString}`))
        //   return {
        //     ...nextState,
        //     value: enteredString,
        //   };
    }
    return nextState;
};

export { formatPhoneToDisplayView, getOnlyDigets, handlePhoneBeforeMaskedStateChange, isPhoneCodeAllowed, isPhoneLengthValid, normalizePhone, normalizeRussianCountryCode };
//# sourceMappingURL=phone.js.map
